import React from 'react';
import Accordion from 'devextreme-react/accordion';
import { Button } from 'devextreme-react/button';
import { downloadItems } from '../../api/s3';
import './AXPCAssistant.scss';

export default function AXPCAssistantReferences({ references, onReferenceRemoved }) {
  if (!references) {
    return null;
  }

  const itemTitleRender = (item) => {
    let title = item.title;
    if (!title && item.excerpt) {
      title = item.excerpt.substring(0, 200) + (item.excerpt.length > 200 ? '...' : '');
    }
    const handleRemoveClick = (e) => {
      e.event.stopPropagation();
      if (onReferenceRemoved) {
        onReferenceRemoved(item);
      }
    };

    return (
      <div className="d-flex justify-content-between align-items-center w-100">
        <div className="reference-title">{title || 'Reference'}</div>
        <Button
          icon="remove"
          stylingMode="text"
          onClick={handleRemoveClick}
        />
      </div>
    );
  };

  const renderReference = (item) => {
    const url = item.uri || '#';
    const content = item.text || 'No content available.';
    const bucketName = 'org.axpx.aiagentkb';
    const isS3File = url.includes(bucketName) || url.includes('.s3') || url.includes('s3.amazonaws.com') || url.startsWith('s3://');

    const handleS3Click = (e) => {
      e.preventDefault();
      try {
        let key = '';
        if (url.startsWith('s3://')) {
          const withoutProtocol = url.substring(5);
          const firstSlash = withoutProtocol.indexOf('/');
          key = firstSlash !== -1 ? withoutProtocol.substring(firstSlash + 1) : withoutProtocol;
        } else {
          const s3Url = new URL(url);
          let pathname = s3Url.pathname.substring(1);
          if (pathname.startsWith(bucketName + '/')) {
            key = pathname.substring(bucketName.length + 1);
          } else {
            key = pathname;
          }
        }

        if (key.includes('?')) {
          key = key.split('?')[0];
        }

        const name = key.split('/').pop();
        downloadItems([{ key, name, isDirectory: false }]);

      } catch (error) {
        console.error("Error processing S3 URL for download:", error, url);
        window.open(url, '_blank', 'noopener,noreferrer');
      }
    };

    if (isS3File) {
      return (
        <div>
          <a href={url} onClick={handleS3Click}>Download Source</a>
          <p style={{ fontSize: 'smaller' }}>{content}</p>
        </div>
      );
    }

    return (
      <div>
        <a href={url} target="_blank" rel="noopener noreferrer">Navigate to Source</a>
        <p style={{ fontSize: 'smaller' }}>{content}</p>
      </div>
    );
  };

  return (
    <Accordion
      dataSource={references}
      itemRender={renderReference}
      itemTitleRender={itemTitleRender}
      collapsible={true}
      multiple={true}
      animationDuration="450"
    />
  );
}
